const SiteRegistrationState = {
  registrationDetails: {},
  checklistDetails: [],
  statusHistory: []
};

export default SiteRegistrationState;
